var _defs, _rect, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#19afad;}.cls-1{opacity:0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.78,10.89H13.11V4.22a1.11,1.11,0,1,0-2.22,0v6.67H4.22a1.11,1.11,0,0,0,0,2.22h6.67v6.67a1.11,1.11,0,0,0,2.22,0V13.11h6.67a1.11,1.11,0,0,0,0-2.22Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.13982535.svg";
export { ForwardRef as ReactComponent };